module.exports = __webpack_public_path__ + "img/v4.16b1c8bf.jpg";